/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Intake_Weight_Hint_LbInputs */

const en_us2_body_assessment_intake_weight_hint_lb = /** @type {(inputs: Body_Assessment_Intake_Weight_Hint_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In lb, as of today. Weight goes straight into the equation.`)
};

const pt_br2_body_assessment_intake_weight_hint_lb = /** @type {(inputs: Body_Assessment_Intake_Weight_Hint_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em lb, o de hoje. O peso entra direto na equação.`)
};

const es_419_body_assessment_intake_weight_hint_lb = /** @type {(inputs: Body_Assessment_Intake_Weight_Hint_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En lb, el de hoy. El peso entra directo en la ecuación.`)
};

const pt_pt2_body_assessment_intake_weight_hint_lb = /** @type {(inputs: Body_Assessment_Intake_Weight_Hint_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em lb, o de hoje. O peso entra diretamente na equação.`)
};

const fr_fr2_body_assessment_intake_weight_hint_lb = /** @type {(inputs: Body_Assessment_Intake_Weight_Hint_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En lb, celui d'aujourd'hui. Le poids entre directement dans l'équation.`)
};

const de_de2_body_assessment_intake_weight_hint_lb = /** @type {(inputs: Body_Assessment_Intake_Weight_Hint_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In lb, von heute. Das Gewicht geht direkt in die Gleichung ein.`)
};

const it_it2_body_assessment_intake_weight_hint_lb = /** @type {(inputs: Body_Assessment_Intake_Weight_Hint_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In lb, quello di oggi. Il peso entra direttamente nell'equazione.`)
};

/**
* | output |
* | --- |
* | "In lb, as of today. Weight goes straight into the equation." |
*
* @param {Body_Assessment_Intake_Weight_Hint_LbInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_intake_weight_hint_lb = /** @type {((inputs?: Body_Assessment_Intake_Weight_Hint_LbInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Intake_Weight_Hint_LbInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_intake_weight_hint_lb(inputs)
	if (locale === "es-419") return es_419_body_assessment_intake_weight_hint_lb(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_intake_weight_hint_lb(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_intake_weight_hint_lb(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_intake_weight_hint_lb(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_intake_weight_hint_lb(inputs)
	return en_us2_body_assessment_intake_weight_hint_lb(inputs)
});
export { body_assessment_intake_weight_hint_lb as "body-assessment.intake_weight_hint_lb" }